import { AppUtils } from '../../../../../shared/utils/index';

export enum Weekday {
	MONDAY = "Mo",
	TUESDAY = "Di",
	WENDSDAY = "Mi",
	THURSDAY = "Do",
	FRIDAY = "Fr",
	SATURDAY = "Sa",
	SUNDAY = "So"
}

export class BusinessHoursModel {
	private wochentag: Weekday;
	public get Wochentag(): Weekday {
		return this.wochentag;
	}
	public set Wochentag(value: Weekday) {
		this.wochentag = value;
	}
	private von: string;
	public get Von(): string {
		return this.von;
	}
	public set Von(value: string) {
		this.von = value;
	}
	private bis: string;
	public get Bis(): string {
		return this.bis;
	}
	public set Bis(value: string) {
		this.bis = value;
	}

	constructor(initialProperties?: Partial<BusinessHoursModel>) {
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	public static createFromObject(dataObject: { [key: string]: any }): BusinessHoursModel {
		return AppUtils.Helper.createFromMap(dataObject, BusinessHoursModel);
	}
}